/**
 * @param {{ ticker: string, market: string, stockName?: string | null }} options
 */
export function buildAnalysesListStockFilterValue({
  ticker,
  market,
  stockName
}) {
  return {
    label: stockName ? `${ticker} - ${stockName}` : ticker,
    ticker,
    value: {
      ticker,
      market
    }
  };
}
